import { Entities } from "@/shared/form/entities";
import {
  CrudListEntities,
  DynamicAttributeFieldReferenceFragment,
  HierarchyElementType,
} from "gql/graphql";
import { AnyInput } from "../dynamic-attribute-field-input-types";
import { CompanyStructureSelect } from "@/modules/common/entities/company-structure/select";

type DynamicAttributeFieldReferenceProps = AnyInput<{
  meta: DynamicAttributeFieldReferenceFragment;
}>;

export function DynamicAttributeFieldReference({
  meta,
  ...rest
}: DynamicAttributeFieldReferenceProps) {
  if (meta.crudEntity === CrudListEntities.Hierarchy) {
    return (
      <CompanyStructureSelect
        className="w-full"
        types={
          Array.isArray(meta.options)
            ? (meta.options as HierarchyElementType[])
            : undefined
        }
        getPopupContainer={(triggerNode) => triggerNode.parentNode}
        {...rest}
      />
    );
  }

  return (
    <Entities
      type={meta.crudEntity}
      allowClear
      showSearch
      optionFilterProp="label"
      {...rest}
    />
  );
}
